<template>
  <version :system="PROJECT_NAME" :commit="commit" :versions="versions" />
</template>
<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { EnvCode, getSiteEnv } from '@tencent/iegsp-common/tools/env';
import { request } from '@tencent/iegsp-common/request';
import version from '@tencent/iegsp-common/components/version/index.vue';
import { getParams } from '@tencent/iegsp-common/components/version/version';
import { PROJECT_NAME } from '@/config/global';
const commit = ref({});
const versions = ref([]);
onMounted(() => {
  // 暂时关闭版本分支获取
  if (false && getSiteEnv() === EnvCode.test) {
    if (import.meta.env.VITE_GIT_COMMIT) {
      commit.value = import.meta.env.VITE_GIT_COMMIT;
    }
    request.post(getParams(PROJECT_NAME)).then((res) => {
      if (res.data?.list?.length) {
        versions.value = res.data.list.map((i) => ({ label: i.name, value: i.branch }));
      }
    });
  }
});
</script>
